

import { Component, Prop, Vue } from 'vue-property-decorator';
import { form7StatusInfoType } from '@/types/Information/Form7';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form7ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form7StatusInfoType;

}
